import React, {Component} from 'react'
import LoanListPageUI from './LoanListPageUI'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class LoanListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      loanList: null,
      repaymentList: null,
      loanCount: null
    }
  }

  render() {
    return (
      <LoanListPageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        repaymentList={this.state.repaymentList}
        onCreateClick={this.onCreateClick}
        onRefreshClick={this.onRefreshClick}
        repaymentList={this.state.repaymentList}
        loanCount={this.state.loanCount}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoanList(context)
    this.getLoanRepaymentList(context)
    this.getMessages(context);
  }

  getLoanList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/loans`,
      cacheKey: CacheKeys.Loans(context.session.accountId),
      callback: this.getLoanListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanListCallback = (response) => {
    console.dir(response)
    let loanList = response.loanList
    this.setState({
     errorList: response.errorList,
     loanList: response.loanList,
    })
  }

  getLoanRepaymentList(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/loans/repayments`,
      cacheKey: CacheKeys.LoanRepayments(context.session.accountId),
      callback: this.getLoanRepaymentListCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanRepaymentListCallback = (response) => {
    let repaymentList = response.repaymentList
    this.setState({
     errorList: response.errorList,
     repaymentList: response.repaymentList,
     loanCount: response.loanCount
    })
  }

  onCreateClick  = () => {
    // redirect to new loan
    window.location.href = '/loans/requested/new'
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Loans(context.session.accountId))
    CacheManager.removeObject(CacheKeys.LoanRepayments(context.session.accountId))
    this.setState({
      errorList: null,
      loanList: null,
      repaymentList: null
    }, () => {
      this.getLoanList(context)
      this.getLoanRepaymentList(context)
    })
  }

  getMessages(context) {
    let arr = [
      'c_cancel',
      'c_loans',
      'c_loan_application',
      'c_loan_amount',
      'c_loan_tenure',
      'c_loan_accept_tnc',
      'c_purpose_of_loan',
      'c_proceed',
      'c_refresh'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_account_loan_requested_new', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList: response.messageList})
  }

}

export default LoanListPageSF
